import React from "react";

// Components
import { CardInfo } from "Common/Components";
import {
  GeneralInfoPage,
  LocationPage,
  ReasonsPage,
  OptionalSettingsPage,
} from "./index";

// Common
import {
  MoreInfoAccordion,
  messagesTypeFields,
  MessagePreview,
} from "../../Common";

const ReviewPage = ({ formik }) => {
  return (
    <>
      <CardInfo
        title="Review Information"
        tooltipInfo="Review the client's information before finalizing the creation process."
      ></CardInfo>

      <GeneralInfoPage formik={formik} viewOnly />

      {formik.values.settings.appointmentLocations && (
        <LocationPage formik={formik} viewOnly />
      )}

      {formik.values.settings.appointmentReasons && (
        <ReasonsPage formik={formik} viewOnly />
      )}

      <CardInfo
        title="Notification Settings"
        tooltipInfo="These messages will be sent to the client via SMS"
      />
      <MoreInfoAccordion />
      {messagesTypeFields.map((field) => (
        <CardInfo
          title={field.label}
          tooltipInfo={field.helperText}
          isHeading={false}
        >
          <MessagePreview
            formik={formik}
            field={field}
            formikValue="defaultTextMessages"
            clinic={formik.values}
          />
        </CardInfo>
      ))}

      <OptionalSettingsPage formik={formik} viewOnly />
    </>
  );
};

export default ReviewPage;
